var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 37.6627C18.1407 37.6627 19.89 35.9134 19.89 33.7754V14.3385C19.89 12.2005 18.1407 10.4512 16.0026 10.4512C13.8645 10.4512 12.1152 12.2005 12.1152 14.3385V33.7754C12.1152 35.9134 13.8645 37.6627 16.0026 37.6627ZM27.6647 14.3385V33.7754C27.6647 35.9134 29.414 37.6627 31.5521 37.6627C33.6901 37.6627 35.4394 35.9134 35.4394 33.7754V14.3385C35.4394 12.2005 33.6901 10.4512 31.5521 10.4512C29.414 10.4512 27.6647 12.2005 27.6647 14.3385Z",
    fill: "#7C2928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.b79043005dcba72128205b8ede2eb72c.svg";
export { ForwardRef as ReactComponent };